var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header__cart-icon",on:{"click":function($event){return _vm.redirectToCart()}}},[_c('a',{attrs:{"href":_vm.cart.checkoutUrl}},[_c('div',{staticClass:"header__cart-label"},[_vm._v(_vm._s('('+_vm.cart.quantity+')'))])])])}
var staticRenderFns = []

export { render, staticRenderFns }